import React, { useEffect, useState } from "react";

const Mouse = () => {
    
    const [X, setX] = useState(0);
    const [Y, setY] = useState(0);
    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        
        const listenMove = (event) => {
            setX(event.screenX - 100)
            setY(event.screenY - 225)
        }
        document.querySelector('#root').addEventListener( 'mousemove', listenMove );

        const src = "./cursor-small.webp";
        const img = new Image();
        img.src = src;
        img.onload = () => {
            setImageSrc(src);
        };
    })

    return (<div id="theme-mouse" className="opacity-0 transition-opacity fixed z-[1000000] h-24 w-24 pointer-events-none mouse" style={{
        top: Y + 75 + 'px',
        left: X + 45 + 'px',
        backgroundImage:`url(${imageSrc})`,
        backgroundSize:'contain',
        backgroundRepeat:'no-repeat',
        backgroundPosition:'center',
    }} />)

}

export default Mouse